<div *ngIf="isBannerVisible"
     [class.loaded]="isBannerListLoaded"
     class="ad-banner">
  <div *ngFor="let image of displayedImages"
       class="banner-image-wrapper">
    <a (click)="businessAction(image.CampaignId)"
       [href]="image.Link"
       target="_blank">
      <picture>
        <source [media]="BannerMediaQueryThreshold"
                [srcset]="image.AdditionalImage">

        <img [src]="image.Image"
             (load)="businessFocus(image.CampaignId)"
             (error)="bannerImageError()"
             alt="Ad"
             class="banner-image">

        <div *ngIf="image.Advertisement"
             class="banner-image-ad-label">
          реклама
        </div>
      </picture>
    </a>

    <button class="banner-image-close-btn"
            mat-icon-button
            (click)="businessClose(image.CampaignId)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
